const setWatermark = (str) => {
  const id = '1.23452384164.123412415';

  if (document.getElementById(id) !== null) {
    // @ts-ignore
    document.body.removeChild(document.getElementById(id));
  }

  const can = document.createElement('canvas');
  can.width = 160;
  can.height = 180;

  const cans = can.getContext('2d');
  if (cans) {
    cans.rotate((-20 * Math.PI) / 180);
    cans.font = '16px Vedana';
    cans.fillStyle = 'rgba(200, 200, 200, 0.40)';
    cans.textAlign = 'left';
    cans.textBaseline = 'Middle';
    cans.fillText(str, can.width / 16, can.height / 2);
  }

  const div = document.createElement('div');
  div.id = id;
  const styleStr = `
    pointer-events: none;
    top: 70px;
    left:200px;
    position: fixed;
    z-index: 100;
    width: ${document.documentElement.clientWidth - 50}px;
    height: ${document.documentElement.clientHeight - 100}px;
    background: url(${can.toDataURL('image/png')}) left top repeat;
  `;
  div.setAttribute('style', styleStr);
  document.body.appendChild(div);

  const windowOb = window.MutationObserver;
  if (windowOb) {
    const ob = new MutationObserver(() => {
      if (div.getAttribute('style') !== styleStr && div) {
        // ob.disconnect()
        // ob = null
        div.setAttribute('style', styleStr);
      }
    });
    ob.observe(document.body, {
      attributes: true,
      subtree: true,
      childList: true,
    });
  }
  return id;
};

// 该方法只允许调用一次
const watermark = {
  set: (str) => {
    let id = setWatermark(str);
    setInterval(() => {
      if (document.getElementById(id) === null) {
        id = setWatermark(str);
      }
    }, 500);
    window.onresize = () => {
      setWatermark(str);
    };
  },
};

export default watermark;
